import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'site-modules/shared/components/link/link';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';

const LINK_CLASS_NAME = 'd-flex flex-column gap-0_75 fw-bold rounded-12';

export const YearLinkItem = React.memo(
  ({
    name = null,
    year = null,
    url = null,
    imageUrl = null,
    currentYear = null,
    noFollow = false,
    trackingId = null,
  }) => {
    const itemContent = (
      <Fragment>
        {!!imageUrl && (
          <AspectRatioContainer aspectRatio="3:2" className="rounded-12">
            <img
              src={imageUrl}
              loading="lazy"
              alt=""
              data-tracking-id={year === currentYear ? undefined : `${trackingId}_image`}
              data-tracking-value={year}
            />
          </AspectRatioContainer>
        )}
        {name}
      </Fragment>
    );

    return (
      <li className="year-link-item">
        {year === currentYear ? (
          <div className={LINK_CLASS_NAME}>{itemContent}</div>
        ) : (
          <Link
            to={url}
            className={LINK_CLASS_NAME}
            rel={noFollow ? 'nofollow' : undefined}
            data-tracking-id={trackingId}
            data-tracking-value={year}
          >
            {itemContent}
          </Link>
        )}
      </li>
    );
  }
);

YearLinkItem.propTypes = {
  name: PropTypes.string,
  year: PropTypes.string,
  url: PropTypes.string,
  imageUrl: PropTypes.string,
  currentYear: PropTypes.string,
  trackingId: PropTypes.string,
  noFollow: PropTypes.bool,
};
